"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaypalShippingOptions = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function getPaypalShippingOptions() {
    const { MAX_STRING_LENGTH: maxStringSize, MAX_SHIPPING_OPTIONS_LENGTH: maxOptions } = src_1.paypalConstants;
    const { selected_shipping: selectedShipping, available_shipping_lines: shippingLines } = (0, checkout_frontend_library_1.getShipping)();
    const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
    const options = [];
    const filteredShippingLines = shippingLines.filter(line => line.id !== selectedShipping.id);
    if (selectedShipping) {
        options.push({
            id: selectedShipping.id.substring(0, maxStringSize),
            label: selectedShipping.description.substring(0, maxStringSize),
            amount: {
                currency_code: currencyCode,
                value: (0, src_1.getValueByCurrency)(selectedShipping.amount, currencyCode)
            },
            type: 'SHIPPING',
            selected: true
        });
    }
    filteredShippingLines.forEach(line => {
        options.push({
            id: line.id.substring(0, maxStringSize),
            label: line.description.substring(0, maxStringSize),
            amount: {
                currency_code: currencyCode,
                value: (0, src_1.getValueByCurrency)(line.amount, currencyCode)
            },
            type: 'SHIPPING',
            selected: false
        });
    });
    return options.slice(0, maxOptions);
}
exports.getPaypalShippingOptions = getPaypalShippingOptions;
